import React, { useEffect, useContext, useState } from 'react';
import _ from 'lodash';

import AppContext from '../../../context';
import { fetchTopGainersLosers, cancelPrevFetch } from '../../../../api';
import TopGainersLosersTable from './top_gainers_losers_table.component';
import { ErrorBlock, Loader } from '../../common/common';
import NoData from '../../tabs/common/no_data/no_data.component';
import NoActivePositions from '../../tabs/common/no_active_positions/no_active_positions.component';
import './top_gainers_losers.component.css';

const TopGainersLosers = (props) => {
  const context = useContext(AppContext);
  //map state to props
  const { portfolioId, state, setState } = props;
  const { data, isLoaderVisible, error } = state;
  //mobile
  const [card, setCard] = useState('gainers');

  const hasEquity = (pfId) => {
    if (pfId === 'family') {
      return context.portfolios.some((pf) => pf.has_equity);
    }
    return context.portfolios.find((pf) => pf.id == pfId).has_equity;
  };

  const hasActivePos = (pfId) => {
    if (pfId === 'family') {
      return context.portfolios.some((pf) => pf.has_active);
    }
    return context.portfoliosById[pfId].has_active;
  };

  useEffect(() => {
    const getTopGainersLosers = async () => {
      try {
        const res = await fetchTopGainersLosers(portfolioId);
        let data = res.data;
        //gainers
        if (data.gainers.length) {
          const dummyRowsG = 3 - data.gainers.length;
          if (dummyRowsG) {
            for (let index = 0; index < dummyRowsG; index++) {
              data.gainers.push([null, null, null]);
            }
          }
        }
        //losers
        if (data.losers.length) {
          const dummyRowsL = 3 - data.losers.length;
          if (dummyRowsL) {
            for (let index = 0; index < dummyRowsL; index++) {
              data.losers.push([null, null, null]);
            }
          }
        }
        setState('data', data);
      } catch (error) {
        if (error.message === 'canceled') return;
        setState('error', 'Something went wrong');
      }
      setState('isLoaderVisible', false);
    };
    cancelPrevFetch('fetchTopGainersLosers');
    if (!data) getTopGainersLosers();
  }, [portfolioId, data]);

  return (
    <section className="top_gainers_losers__cont">
      {!hasActivePos(portfolioId) ? (
        <NoActivePositions />
      ) : (
        <>
          {hasEquity(portfolioId) ? (
            <>
              {error ? (
                <ErrorBlock />
              ) : (
                <>
                  <div className="gainers_losers_toggler">
                    <button
                      type="button"
                      className={card === 'gainers' ? 'active' : ''}
                      onClick={() => setCard('gainers')}
                    >
                      Top Gainers
                    </button>
                    <button
                      type="button"
                      className={card === 'losers' ? 'active' : ''}
                      onClick={() => setCard('losers')}
                    >
                      Top Losers
                    </button>
                  </div>
                  <div
                    className={`top_gainers_losers ${
                      card === 'losers' ? 'hidden_mob' : ''
                    }`}
                  >
                    {isLoaderVisible ? (
                      <Loader />
                    ) : data.gainers.length ? (
                      <TopGainersLosersTable
                        data={data.gainers}
                        changeColor="c-positive"
                      />
                    ) : (
                      <div className="no_gainers">No Gainers</div>
                    )}
                  </div>
                  <div
                    className={`top_gainers_losers mr-0 ${
                      card === 'gainers' ? 'hidden_mob' : ''
                    }`}
                  >
                    {isLoaderVisible ? (
                      <Loader />
                    ) : data.losers.length ? (
                      <TopGainersLosersTable
                        data={data.losers}
                        changeColor="c-negative"
                      />
                    ) : (
                      <div className="no_losers">No Losers</div>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <NoData instrument="equity" />
          )}
        </>
      )}
    </section>
  );
};

export default TopGainersLosers;
